export enum ApiPaths {
    eventTypes = 'api/v1/EventTypes',
    events = 'api/v1/events',
    calendarDays = 'api/v1/calendarDays'
}
